class QueueMessageSummaryRow {
    constructor(
        public type: string,
        public totalCount: number,
        public readyCount: number,
        public scheduledCount: number,
        public errorCount: number,
        public maxTries: number,
        public oldestQueuedAt?: string,
        public nextTry?: string) {
        //
    }

    public static fromPOJO(data: any) {
        return new QueueMessageSummaryRow(
            data.type,
            data.totalCount,
            data.readyCount,
            data.scheduledCount,
            data.errorCount,
            data.maxTries,
            data.oldestQueuedAt,
            data.nextTry
        );
    }
}

export default QueueMessageSummaryRow;
